import React, { useMemo } from 'react';
import { getCoreRowModel, Table, useReactTable } from '@tanstack/react-table';
import { IHolisticRubricDescription, IRubric } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import HolisticRubric from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/HolisticRubric';
import { HolisticRubricProps }
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/HolisticRubric/HolisticRubric';
import { createHolisticRubricColumns }
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/HolisticRubric/HolisticRubric.utils';
import PreviewDescriptionCell
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/HolisticRubric/PreviewDescriptionCell';

type HolisticRubricPreviewProps = {
  columnSizes?: { description?: string, score?: string },
  holisticRubricProps?: Partial<HolisticRubricProps>,
  locale?: Lowercase<Locale>,
  rubric: IRubric,
};

const DEFAULT_COLUMN_SIZES = { description: '80%', score: '20%' };

const HolisticRubricPreview = ({
  columnSizes = DEFAULT_COLUMN_SIZES,
  holisticRubricProps = {},
  locale = 'en',
  rubric,
}: HolisticRubricPreviewProps) => {
  const holisticColumns = useMemo(
    () => createHolisticRubricColumns({
      DescriptionCell: PreviewDescriptionCell,
      columnSizes,
      locale,
    }),
    [columnSizes, locale],
  );

  const holisticTable = useReactTable({
    columns: holisticColumns,
    data: rubric.rubric_data as IHolisticRubricDescription[],
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <HolisticRubric
      hasHeaders={false}
      table={holisticTable as Table<IHolisticRubricDescription>}
      {...holisticRubricProps}
    />
  );
};

export default HolisticRubricPreview;
